import React, {Component} from "react"
import {Row, Overlay, OverlayTrigger, Tooltip} from "react-bootstrap"
import QRCode from "qrcode.react"

import Hr from "@irati/ui/src/Layout/Hr"
import {FormattedMessage, FormattedDate, injectIntl, InjectIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/perks/perks"
import id from "@irati/utils/id"
import isTimeLimited from "@irati/deals/helpers/deals/isTimeLimited"
import {Voucher} from "@irati/deals/types"
import {DealExternalLinks} from "@irati/types"
import StockType from "@irati/stock/enums/StockType"
import {Label} from "@irati/ui/src/Typography"

import LabelValue from "./LabelValue"
import CodeCTA from "./CodeCTA"
import DealSuccessCopyCodeButton from "./DealSuccessCopyCodeButton"
import ProductCode from "./styled/ProductCode"
import QrContainer from "./styled/QrContainer"
import TicketContainer from "./styled/TicketContainer"
import {StyledTooltip, Pin} from "./styled/Code"

interface Props extends InjectIntl {
  voucher: Voucher,
  externalLinks?: Partial<DealExternalLinks>
}

interface State {
  showCopyTooltip: boolean
}

class TicketCode extends Component<Props, State> {
  codeRef: any

  constructor(props: Props) {
    super(props)

    this.codeRef = React.createRef()

    this.state = {
      showCopyTooltip: false
    }
  }

  copyToolTipProps = () => {
    return {
      show: this.state.showCopyTooltip,
      target: () => this.codeRef.current
    }
  }

  handleCopy = () => {
    tracking.redeemPerkCopyCode(this.props.voucher.deal)
    this.setState({showCopyTooltip: true})
    setTimeout(() => {
      this.setState({showCopyTooltip: false})
    }, 2000)
  }

  voucherTooltip = () => (
    <StyledTooltip id="voucher" placement="bottom">
      {this.props.voucher.code}
    </StyledTooltip>
  )

  render() {
    const {formatMessage, externalLinks} = this.props
    const {expiry, pin, code, product, type, deal} = this.props.voucher
    const isQrCode = type === StockType.QR

    return (
      <TicketContainer id={id("code", this.props)}>
        {isQrCode && (
          <QrContainer>
            <QRCode value={code} size={600} />
          </QrContainer>
        )}
        {product && (
          <Label display="inline-block" marginBottom={1}>
            {product.name}
          </Label>
        )}
        <OverlayTrigger placement="bottom" overlay={this.voucherTooltip()}>
          <ProductCode isQrCode={isQrCode} onClick={() => tracking.redeemPerkCopyCode(deal)} ref={this.codeRef}>
            {code}
          </ProductCode>
        </OverlayTrigger>
        {externalLinks?.web && <DealSuccessCopyCodeButton voucher={this.props.voucher} />}
        <Overlay {...this.copyToolTipProps()} placement="bottom">
          <Tooltip id="copiedToClipboard" positionLeft={0}>
            <FormattedMessage id="perks.components.tickets.ticket.code.copied" />
          </Tooltip>
        </Overlay>
        {pin && <Pin value={pin} label={formatMessage({id: "perks.components.tickets.ticket.code.PIN"})} />}
        {expiry && !isTimeLimited(deal) && (
          <LabelValue
            value={<FormattedDate value={expiry} year="numeric" month="2-digit" day="numeric" />}
            label={formatMessage({id: "perks.components.tickets.ticket.code.expDate"})} />
        )}
        <Hr />
        <Row>
          <CodeCTA voucher={this.props.voucher} externalLinks={this.props.externalLinks} onCopy={this.handleCopy} />
        </Row>
      </TicketContainer>
    )
  }
}

export default injectIntl(TicketCode)
